import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import NewText from "./NewText";
import Breaker from "./Breaker";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// GlobalFooter => Rename all instances to use
type GlobalFooterProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _GlobalFooter = (props: GlobalFooterProps) => {
  return (
    <>
      <Breaker _size={"3rem"} />
      <div className={props.className}>
        <NewText
          _text={`Elaborado por |{=:mailto:brianwoolfolk@hotmail.com, $:$0}|Brian Woolfolk||. WhatsApp: |{=:tel:6621844819,$:$0}|662 184 4819||.`}
          _type={"subtitle"}
          _variant={3}
          _style={{ color: "#0dcaf0" }}
          _styleText={{
            _emphasis: {
              _col: ["#E3AC14"],
            },
          }}
        />
      </div>
    </>
  );
};

// ################################ STYLES ################################
const GlobalFooter = styled(_GlobalFooter).attrs((props): GlobalFooterProps => {
  return { ...props };
})`
  ${(props) => {
    var extend = false;
    const hh = document.getElementById("#root")?.scrollHeight || 0;
    const bodyhh = document.body.scrollHeight;

    if (hh <= bodyhh) extend = true;

    return css`
      position: ${extend ? "absolute" : "relative"};
      bottom: 0%;
      width: 100%;
      background-color: #2a296e;

      ${parseCSS(props._style)}
    `;
  }}
`;

// ################################ EXPORTS ################################

export default GlobalFooter;
